import { VxeLayoutBody } from 'vxe-pc-ui';
export default {
  name: 'XLayoutContent',
  components: {
    VxeLayoutBody
  }
};